import React, { Component } from 'react';
import { motion } from 'framer-motion';
import StarStory from '../components/StarStory';
import AnimatedCounter from '../components/AnimatedCounter';
const EpicGamesPage = () => {
  return <div className="bg-white min-h-screen" data-id="element-210">
      <div className="container mx-auto px-4 py-16" data-id="element-211">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-12" data-id="element-212">
          <img src="https://logo.clearbit.com/epicgames.com" alt="Epic Games logo" className="w-24 h-24 object-contain" data-id="element-213" />
          <div data-id="element-214">
            <motion.h1 className="text-4xl font-bold text-gray-800 mb-2" initial={{
            opacity: 0.5
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-215">
              Lead PM at Epic Games
            </motion.h1>
            <motion.p className="text-xl text-gray-700 mb-4" initial={{
            opacity: 0.5
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-216">
              2019 — 2021
            </motion.p>
            <motion.div className="bg-gray-100 p-4 rounded-lg" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-217">
              <p className="text-gray-700" data-id="element-218">
                <span className="font-bold" data-id="element-219">Context:</span> Fortnite peak years.
                Company valued at $32B.
              </p>
            </motion.div>
          </div>
        </div>
        {/* STAR Stories */}
        <StarStory title="Fortnite Chapter 2 Relaunch" situation="By mid-2019, Fortnite's free-to-play growth had slowed, and daily active users were declining by 7% month-over-month. Engagement was stagnating, and competitors were gaining ground." task="As Lead PM, I had to design a relaunch strategy that would reverse decline and reignite growth." action="I coordinated content pipelines across design, engineering, and live ops. We built a Chapter 2 launch moment, with an entirely new island map, revamped progression systems, and stronger reward loops. I pushed for coordinated marketing with influencers and streamers to amplify hype. I also worked with analytics to pre-test balance changes via controlled rollouts." result="Chapter 2's release reversed decline: DAUs surged +28% within 60 days, and session length increased +18%. Fortnite returned to the #1 streamed game on Twitch." imageUrl="https://via.placeholder.com/600x400?text=Fortnite+Chapter+2" imageAlt="Fortnite Chapter 2 promotional art" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-221">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-222">
                User Growth Trend
              </h4>
              <div className="relative h-32 w-full" data-id="element-223">
                <div className="absolute bottom-0 left-0 h-16 w-full bg-gray-100 rounded" data-id="element-224">
                  <div className="relative h-full w-full" data-id="element-225">
                    {/* Declining Line */}
                    <motion.div className="absolute bottom-8 left-0 h-1 w-1/3 bg-red-500 origin-left" initial={{
                rotate: 0
              }} animate={{
                rotate: -10
              }} transition={{
                duration: 0.5
              }} data-id="element-226" />
                    {/* Growth Line */}
                    <motion.div className="absolute bottom-8 left-1/3 h-1 bg-green-500 origin-left" initial={{
                width: 0,
                rotate: 0
              }} animate={{
                width: '66%',
                rotate: 30
              }} transition={{
                duration: 1.5,
                delay: 0.5
              }} data-id="element-227" />
                    {/* Indicator */}
                    <div className="absolute bottom-6 left-1/3 h-4 w-1 bg-gray-400" data-id="element-228" />
                    {/* Labels */}
                    <div className="absolute bottom-0 left-0 text-xs text-gray-600" data-id="element-229">
                      -7% MoM
                    </div>
                    <div className="absolute bottom-0 right-0 text-xs text-gray-600" data-id="element-230">
                      +28% Growth
                    </div>
                  </div>
                </div>
              </div>
            </div>} data-id="element-220" />
        <StarStory title="Travis Scott Concert" situation="Epic wanted to set a new industry benchmark with in-game events. The challenge: host a virtual concert at unprecedented scale." task="I had to coordinate product/infra readiness for 12M+ concurrent users." action="I led cross-functional pods with 150+ engineers, artists, and designers. We stress-tested servers, introduced region-based sharding, and rebuilt event scheduling to handle spikes. I also collaborated with the creative team on interactive elements: gravity shifts, giant avatars, synchronized lighting." result="The Travis Scott concert drew 12.3M concurrent players, setting a record for live events. Engagement spiked globally, and Fortnite was covered as a cultural phenomenon in Rolling Stone, Billboard, and The Verge." imageUrl="https://via.placeholder.com/600x400?text=Travis+Scott+Concert" imageAlt="Stills from Travis Scott Fortnite concert" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-232">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-233">
                Concert Attendance
              </h4>
              <div className="flex justify-center mb-4" data-id="element-234">
                <AnimatedCounter start={0} end={12.3} suffix="M" decimals={1} data-id="element-235" />
                <span className="ml-2 text-gray-700" data-id="element-236">Concurrent Players</span>
              </div>
              <div className="flex justify-center" data-id="element-237">
                <motion.div className="w-4 h-4 rounded-full bg-[#0FB9B1]" animate={{
            scale: [1, 1.5, 1],
            opacity: [0.7, 1, 0.7]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-238" />
              </div>
            </div>} data-id="element-231" />
        <StarStory title="Patch System Overhaul" situation="Fortnite's two-week patch cycle was plagued by delays. Average release was slipping by 4–6 days, causing missed seasonal beats and frustrated players." task="I needed to simplify patch complexity and ensure on-time launches." action="I redesigned the patch pipeline: fewer simultaneous feature bundles, stricter staging, and automated regression testing. I also aligned release calendars across pods to reduce dependencies." result="On-time delivery improved from 64% → 92%. The tighter cadence drove an estimated <$300M incremental revenue annually, thanks to reliable seasonal content." imageUrl="https://via.placeholder.com/600x400?text=Patch+Notes" imageAlt="Patch notes screenshot with ON TIME overlay" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-240">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-241">
                Release Performance
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-242">
                <span className="text-gray-700" data-id="element-243">On-time Delivery:</span>
                <div className="flex items-center" data-id="element-244">
                  <span className="text-gray-500 mr-2" data-id="element-245">64%</span>
                  <span className="text-gray-700 mx-2" data-id="element-246">→</span>
                  <AnimatedCounter start={64} end={92} suffix="%" data-id="element-247" />
                </div>
              </div>
              <div className="flex justify-center mt-4" data-id="element-248">
                <motion.div className="w-8 h-8 text-green-500" initial={{
            scale: 0
          }} animate={{
            scale: 1,
            rotate: 360
          }} transition={{
            duration: 0.5,
            delay: 1
          }} data-id="element-249">
                  ✓
                </motion.div>
              </div>
            </div>} data-id="element-239" />
        {/* Testimonial */}
        <motion.div className="mt-16 bg-gray-100 p-8 rounded-lg" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-250">
          <p className="text-xl text-gray-700 italic mb-4" data-id="element-251">
            "Aakash was a huge driver of the success of Fortnite Chapter 2,
            couldn't have done it without him."
          </p>
          <p className="text-gray-800 font-bold" data-id="element-252">
            — Jason West, Fortnite Director
          </p>
        </motion.div>
      </div>
    </div>;
};
export default EpicGamesPage;